<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>

        <el-breadcrumb-item> 考级测试</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="5"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center">
          <el-form
            :model="formData"
            ref="ruleForm"
            :rules="rules"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="收件人" prop="post_name">
                  <el-input
                    type="text"
                    placeholder="请输入收件人姓名"
                    v-model="formData.post_name"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="post_phone">
                  <el-input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="formData.post_phone"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="地区" prop="areas">
                  <el-cascader
                    v-model="formData.areas"
                    :options="areaOptions"
                    :props="{ label: 'title' }"
                    class="inputSizeClass"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" prop="address">
                  <el-input
                    type="text"
                    placeholder="请输入详细地址"
                    v-model="formData.address"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-alert
                v-if="row.express_note"
                :title="'物流信息：' + row.express_note"
                type="success"
              >
              </el-alert>
              <el-col v-else class="btn_position_class">
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >确定保存</el-button
                >
                <el-button @click="resetForm('ruleForm')" plain>重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      areaOptions: [],
      rules: {
        areas: [{ required: true, message: "请选择地区", trigger: "blur" }],
        post_name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        post_phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          { min: 5, message: "地址不得少于5个字", trigger: "blur" },
        ],
      },
      formData: {
        areas: [],
      },
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
    };
  },
  components: {
    NewsListItem,
  },
  computed: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id || 0;
    if (that.formData.id) {
      this.fetch();
    }
    that.getAreaOptions();
  },
  methods: {
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (r) => {
        that.areaOptions = r.data;
      });
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/postDetail",
        {
          id: that.formData.id,
        },
        (res) => {
          setTimeout(() => {
            if (res.data.area) {
              res.data.areas = [
                res.data.area.substring(0, 2) + "0000",
                res.data.area.substring(0, 4) + "00",
                res.data.area,
              ];
            } else {
              res.data.areas = [];
            }
          }, 500);
          that.formData = res.data;
          that.row = res.data;
        }
      );
    },
    submitForm(formName) {
      const that = this;
      that.formData["area"] = that.formData.areas[2];
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$api.post("/api/kaoji/applyPostSave", that.formData, (r) => {
            that.$message.success("保存成功");
            that.$router.push({name:'kaojiApplyList'})
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped lang="scss">
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1000px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    padding: 88px 0 20px 40px;
    .inputSizeClass {
      width: 240px;
      height: 40px;
      border-radius: 4px;
    }
    .btn_position_class {
      text-align: center;
      margin: 42px 0 0 0;
      box-sizing: border-box;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
        font-size: 14px;
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// KaojiApplyPost.vue?fc6bd180